import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import renderDaterange from "../../../../Components/Forms/daterange";
import moment from "moment";

const FilterSensor = (props) => {
  const [loading, setLoading] = useState(true);
  const [gemiddelde, setGemiddelde] = useState(0);
  const [verbruik, setVerbruik] = useState(0);
  const [max, setMax] = useState(0);
  const [stand, setStand] = useState(0);
  const [correctie, setCorrectie] = useState(0);

  useEffect(() => {
    if (!props.loading) {
      setLoading(props.loading);
      setGemiddelde(props.gemiddelde.toFixed(2));
      setMax(props.max.toFixed(2));
      setStand(props.sensor.lastvalue);
      if (props.sensor.correctie) setCorrectie(props.sensor.correctie);
      setVerbruik(props.verbruik);
    }
  }, [props.loading, props.gemiddelde, props.max, props.stand, props.verbruik]);

  const onSubmit = (values) => {
    props.changedata(values);
  };

  const onChangeItem = () => {
    setLoading(true);
    setTimeout(() => props.handleSubmit(onSubmit)(), 0);
  };

  const renderLoading = () => {
    if (loading) {
      return (
        <div className="row">
          <div className="col-12">
            <div className="alert alert-info loadingsearch">
              <i className="fas fa-spinner fa-spin me-2"></i>
              Gegevens worden geladen...
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  const welkemeter = (waarde) => {
    if (props.meterSoort === "water") {
      return (waarde / 1000).toFixed(2) + " Kub";
    }
    return waarde + " kWh";
  };

  return (
    <form onSubmit={props.handleSubmit(onSubmit)}>
      <div className="container-fluid">
        <div className="row filter-sensor-stats">
          {/* Date Filter */}
          <div className="col-12 col-lg-4 mb-3">
            <div className="filter-date-section">
              <Field 
                name="datum" 
                type="number" 
                mindate={true} 
                maxdate={false} 
                component={renderDaterange} 
                label="Kies een datum" 
                onChange={onChangeItem} 
              />
            </div>
          </div>
          
          {/* Statistics Grid */}
          <div className="col-12 col-lg-8">
            <div className="row stats-grid">
              <div className="col-6 col-md-3 mb-3">
                <div className="stat-card">
                  <div className="stat-label">Totaal Verbruik</div>
                  <div className="stat-value gemiddelde">{welkemeter(verbruik)}</div>
                </div>
              </div>
              
              <div className="col-6 col-md-3 mb-3">
                <div className="stat-card">
                  <div className="stat-label">Gemiddeld (per dag)</div>
                  <div className="stat-value gemiddelde">{welkemeter(gemiddelde)}</div>
                </div>
              </div>
              
              <div className="col-6 col-md-3 mb-3">
                <div className="stat-card">
                  <div className="stat-label">Piek (per dag)</div>
                  <div className="stat-value gemiddelde">{welkemeter(max)}</div>
                </div>
              </div>
              
              <div className="col-6 col-md-3 mb-3">
                <div className="stat-card">
                  <div className="stat-label">Laatste Meterstand</div>
                  <div className="stat-value gemiddelde">
                    {welkemeter(stand + correctie)} 
                    {correctie != 0 && (
                      <i 
                        className="fa-solid fa-triangle-exclamation fa-xs ms-1" 
                        title="Correctie toegepast"
                      ></i>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Loading Indicator */}
        {renderLoading()}
      </div>
    </form>
  );
};

const mapStateToProps = (state) => ({
  initialValues: {
    datum: { startdate: moment().subtract(14, "days"), enddate: new Date() },
  },
});

export default connect(mapStateToProps)(
  reduxForm({
    form: "filtersensor", // a unique identifier for this form
  })(FilterSensor)
);
